module.exports = __webpack_public_path__ + "img/airplane-1.d162f228.jpg";